import { IItineraryProps } from 'components/shared/ArrayFields/types';
import { SNACKBAR_SKIN } from 'components/shared/Snackbar';
import { showSnackbar } from 'hooks/useSnackbar';
import i18n from 'i18n';
import { ITINERARIES_ITEM_TYPE_TO_KEY_MAP } from 'store/admin/itineraries';

import { confirmAlert } from '../alert';
import { decamelize } from '../humps';
import { TItineraryItemType } from '../types';
import { getBaseRoute } from './docx';
import { getFileByTask, getTaskId, isDownloadingInProgress, getFileDownloadingConfig } from './downloadingTaskManager';
import { ITask } from './types';

interface ISaveAsPDFParams {
  item: IItineraryProps;
  itinerariesItemType: TItineraryItemType;
  translate?: boolean;
}

export async function saveAsPDF({ item, itinerariesItemType, translate = false }: ISaveAsPDFParams) {
  if (isDownloadingInProgress(item.id)) {
    return;
  }

  async function run(withImages: boolean = false) {
    try {
      const proposalRouteName = decamelize(ITINERARIES_ITEM_TYPE_TO_KEY_MAP[itinerariesItemType]);
      const queue = `${getBaseRoute()}/${proposalRouteName}/${item.id}/files/pdf`;
      const taskId = await getTaskId({ withImages }, queue);
      const sessionData: ITask = {
        taskId,
        title: item.title,
        itemId: item.id,
        time: Date.now(),
        queue,
        extension: 'pdf',
      };

      await getFileByTask(getFileDownloadingConfig(sessionData, translate), sessionData);
    } catch (e) {
      window.console.log('Error occurred:', e);

      //@ts-ignore
      showSnackbar({ text: 'Generating PDF error. Please, try again.', type: SNACKBAR_SKIN.ERROR });
    }
  }

  confirmAlert({
    title: translate ? i18n.t('proposal_content.file.pdf_with_images.title') : 'Save PDF with images?',
    confirmButtonText: translate ? i18n.t('common.buttons.no') : 'No',
    cancelButtonText: translate ? i18n.t('common.buttons.yes') : 'Yes',
    onConfirm: () => run(false),
    onCancel: () => run(true),
  });
}
